<template>
  <div class="Chapters">
    <div class="Chapters__content" :class="{ 'is-disabled': $route.meta.name != 'chapters' }">
      <ChaptersMenu v-if="$root.orientation == 'landscape' && !$root.isModeVideo">
        <transition name="Chapter" mode="out-in">
          <Chapter :key="$route.params.chapter" />
        </transition>
      </ChaptersMenu>
      <transition  v-if="$root.isModeVideo" name="Chapter" mode="in-out">
        <Chapter :key="$route.params.chapter" />
      </transition>
    </div>
  </div>
</template>

<script>
import Page from '@/core/mixins/Page'
import ChaptersMenu from '@/components/chapters-menu/ChaptersMenu'
import Chapter from '@/components/chapter/Chapter'

export default {
  name: 'Chapters',
  mixins: [Page],
  components: { ChaptersMenu, Chapter },
  computed: {
    chapters() { return this.$store.getters['data/chapters'] },
  },
  mounted() {

    // // CHECK DIFFERENCE
    // const ms = millis => {
    //   var minutes = Math.floor(millis / 60000)
    //   var seconds = ((millis % 60000) / 1000).toFixed(0)
    //   return minutes + ":" + (seconds < 10 ? '0' : '') + seconds
    // }
    // const musics = {}
    // _.each(this.chapters, chapter => {
    //   if(chapter.key == 'introduction') return
    //   musics[chapter.key] = { }
    //   _.each(chapter.audio.json.sprite, (sound, soundKey) => {
    //     const lang = soundKey.substring(0, 2).toLowerCase()
    //     if(lang == 'fr' || lang == 'en') {
    //       const name = soundKey.substring(3, soundKey.length)
    //       _.set(musics[chapter.key], name + '.' + lang, sound[1])
    //     }
    //   })
    // })
    // _.each(musics, (m,i) => {
    //   _.each(m, (s,j) => {
    //     musics[i][j]['difference_seconde'] = ms(Math.abs(s.en - s.fr))
    //     musics[i][j]['difference_milliseconde'] = Math.abs(s.en - s.fr)
    //   })
    // })
    // console.log(musics)
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Chapters
  position absolute
  height 100%
  width 100%

  &__content
    height 100%
    transition transform 1s, opacity 1s
    &.is-disabled
      opacity .5
      transform scale(.9)

</style>
